<div class="container-fluid py-4">
  <div class="row justify-content-center">
    <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 3 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-7 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 3, 'text-white': i !== 3 }"
              >
                {{ card.value }}
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 3 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mb-4 mt-4">
    <div class="col-12 d-flex align-items-center justify-content-center">
      <a
        class="btn btn-sm"
        [ngClass]="viewMode === 'all' ? 'btn-reg' : 'btn-new'"
        (click)="switchView('all')"
      >
        REGISTRY
      </a>
      <a
        class="btn btn-dark btn-sm btn-new"
        routerLink="/marketing/mediaroom/social"
        >SOCIAL
      </a>
    </div>
  </div>

  <div class="card shadow-sm mb-4">
    <div class="card-body">
      <div class="row pb-3">
        <div class="col-md-12">
          <a
            [routerLink]="['/marketing/mediaroomRegistry/add']"
            class="btn btn-dark btn-sm mt-0 btn-neww"
          >
            NEW
          </a>
        </div>
      </div>
      <div class="row g-3">
        <div class="col-2" *ngIf="viewMode === 'all'">
          <label class="form-label text-xs fw-bold d-block">Status</label>
          <select
            class="form-select form-select-sm text-dark"
            [(ngModel)]="filters.status"
            (change)="applyFilters()"
          >
            <option value="">All</option>
            <option value="draft">Draft</option>
            <option value="review">Review</option>
            <option value="approved">Approved</option>
            <option value="published">Published</option>
            <option value="refresh_due">Refresh Due</option>
            <option value="archived">Archived</option>
          </select>
        </div>

        <div class="col-2">
          <label class="form-label text-xs fw-bold d-block">Pack Type</label>
          <select
            class="form-select form-select-sm text-dark"
            [(ngModel)]="filters.pack_type"
            (change)="applyFilters()"
          >
            <option value="">All</option>
            <option value="city_pack">City Pack</option>
            <option value="service_pack">Service Pack</option>
            <option value="industry_pack">Industry Pack</option>
            <option value="blog_pack">Blog Pack</option>
            <option value="ads_copy_pack">Ads Copy Pack</option>
            <option value="social_pack">Social Pack</option>
            <option value="faq_pack">FAQ Pack</option>
            <option value="trust_pack">Trust Pack</option>
          </select>
        </div>

        <div class="col-md-2">
          <label class="form-label text-xs fw-bold d-block">Vertical</label>
          <select
            class="form-select form-select-sm text-dark"
            [(ngModel)]="filters.vertical"
            (change)="applyFilters()"
          >
            <option value="">All</option>
            <option value="courier">Courier</option>
            <option value="task_runner">Task Runner</option>
          </select>
        </div>
        <div class="col-6">
          <label class="form-label text-xs fw-bold">Search</label>
          <div class="input-group input-group-sm">
            <input
              type="text"
              class="form-control"
              placeholder="Title or ID..."
              [(ngModel)]="searchText"
              (ngModelChange)="applyFilters()"
              list="suggestionsMediaRoom"
              autocomplete="off"
            />
            <span class="input-group-text"><i class="fas fa-search"></i></span>
          </div>
          <datalist id="suggestionsMediaRoom">
            <option
              *ngFor="let suggestion of searchSuggestions"
              [value]="suggestion"
            ></option>
          </datalist>
        </div>
      </div>
    </div>
  </div>

  <div class="card shadow-sm">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th>Content ID</th>
              <th>Title</th>
              <th>Type</th>
              <th>Pack</th>
              <th>Vertical</th>
              <th>Status</th>
              <th>Generation</th>
              <th>Version</th>
              <th>Priority</th>
              <th>Owner</th>
              <th>RefreshDue</th>
              <th>LastRefresh</th>
              <th class="th__status text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of filteredData">
              <td
                class="content-id-cell"
                (click)="showModal('Content ID', item.content_id)"
                title="Click to view full Content ID"
              >
                {{ item.content_id }}
              </td>
              <td>{{ item.title }}</td>
              <td>{{ item.content_type }}</td>
              <td>{{ item.pack_type }}</td>
              <td>{{ item.vertical }}</td>
              <td>
                <span
                  class="badge w-100"
                  [ngClass]="{
                    'badge-info': item.status === 'draft',
                    'badge-warning': item.status === 'review',
                    'badge-primary': item.status === 'approved',
                    'badge-success': item.status === 'published',
                    'badge-danger': item.status === 'refresh_due',
                    'badge-secondary': item.status === 'archived',
                  }"
                >
                  {{ item.status | uppercase }}
                </span>
              </td>

              <td>
                <div class="d-flex flex-column gap-1">
                  <!-- Generation Status -->
                  <span
                    *ngIf="item.generation_status"
                    class="badge w-100"
                    [ngClass]="{
                      'badge-secondary': item.generation_status === 'pending',
                      'badge-success': item.generation_status === 'generated',
                      'badge-primary': item.generation_status === 'reviewed',
                      'badge-danger': item.generation_status === 'failed',
                    }"
                    [title]="
                      item.generation_status === 'failed'
                        ? item.last_generation_error
                        : ''
                    "
                  >
                    {{ item.generation_status | uppercase }}
                  </span>

                  <small
                    *ngIf="item.generation_status === 'failed'"
                    class="text-danger x-small d-block mt-1"
                    style="font-size: 0.7rem; max-width: 150px; line-height: 1"
                  >
                    {{ item.last_generation_error }}
                  </small>
                </div>
              </td>

              <td class="text-center">
                <span
                  class="badge badge-dark"
                  *ngIf="item.current_version_id?.version"
                >
                  v{{ item.current_version_id.version }}
                </span>
                <span
                  class="text-muted"
                  *ngIf="!item.current_version_id?.version"
                  >—</span
                >
              </td>
              <td>
                <span
                  class="badge"
                  [ngClass]="{
                    'badge-info': item.priority === 'low',
                    'badge-warning': item.priority === 'medium',
                    'badge-danger':
                      item.priority === 'high' || item.priority === 'urgent',
                  }"
                >
                  {{ item.priority | uppercase }}
                </span>
              </td>
              <td>{{ item.owner_primary }}</td>
              <td>{{ item.refresh_due_at | date: "shortDate" }}</td>
              <td>{{ item.last_refresh_at | date: "shortDate" }}</td>
              <td>
                <a
                  class="btn btn-link text-dark btn-sm"
                  [routerLink]="['/marketing/mediaroomRegistry/edit', item._id]"
                  title="Edit"
                >
                  <i class="fas fa-pen"></i>
                </a>

                <button
                  *ngIf="item.current_version_id"
                  (click)="openVersionDetail(item.current_version_id)"
                  class="btn btn-link text-info btn-sm"
                  title="View Version Detail"
                >
                  <i class="fas fa-eye"></i>
                </button>

                <!-- Retry Button -->
                <button
                  *ngIf="item.generation_status === 'failed'"
                  (click)="retryGeneration(item._id)"
                  class="btn btn-link text-primary btn-sm"
                  title="Retry generation"
                >
                  <i class="fas fa-sync-alt"></i>
                </button>

                <button
                  *ngIf="item.status === 'review'"
                  (click)="approveItem(item._id)"
                  class="btn btn-link text-success btn-sm"
                  title="Approve"
                >
                  <i class="fas fa-check-circle"></i>
                </button>
                <button
                  *ngIf="
                    item.status === 'published' || item.status === 'refresh_due'
                  "
                  (click)="updateItemStatus(item._id, 'archived')"
                  class="btn btn-link text-warning btn-sm"
                  title="Archive"
                >
                  <i class="fas fa-archive"></i>
                </button>
                <button
                  (click)="deleteData(item._id)"
                  class="btn btn-link text-danger btn-sm"
                  title="Delete"
                >
                  <i class="fas fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal-url-overlay" *ngIf="modalContent" (click)="closeModal()">
  <div class="modal-url-content" (click)="$event.stopPropagation()">
    <div class="modal-url-header">
      <h5 class="mb-0">{{ modalTitle }}</h5>
      <button type="button" class="modal-url-close" (click)="closeModal()">
        &times;
      </button>
    </div>
    <div
      class="modal-url-body text-dark"
      style="word-wrap: break-word; white-space: pre-wrap"
    >
      {{ modalContent }}
    </div>
  </div>
</div>
